// src/components/Opportunities/CustomDateRange.js

import React from 'react';
import * as rdr from 'react-date-range';
import { es } from 'date-fns/locale';
import { isSameDay } from 'date-fns';
import { Button } from 'react-bootstrap'; // Usaremos botones de Bootstrap para el panel

// --- La definición de rangos sigue siendo la misma ---
const today = new Date();
const year = today.getFullYear();

const defineds = {
  startOfQ1: new Date(year, 0, 1),
  endOfQ1: new Date(year, 2, 31),
  startOfQ2: new Date(year, 3, 1),
  endOfQ2: new Date(year, 5, 30),
  startOfQ3: new Date(year, 6, 1),
  endOfQ3: new Date(year, 8, 30),
  startOfQ4: new Date(year, 9, 1),
  endOfQ4: new Date(year, 11, 31),
};

const customStaticRanges = [
  // ... (El array de `customStaticRanges` que definimos antes va aquí, no lo pongo para no alargar, pero asegúrate de que esté)
  { label: `Q1 ${year}`, range: () => ({ startDate: defineds.startOfQ1, endDate: defineds.endOfQ1 }), isSelected(range) { return isSameDay(range.startDate, defineds.startOfQ1) && isSameDay(range.endDate, defineds.endOfQ1); }},
  { label: `Q2 ${year}`, range: () => ({ startDate: defineds.startOfQ2, endDate: defineds.endOfQ2 }), isSelected(range) { return isSameDay(range.startDate, defineds.startOfQ2) && isSameDay(range.endDate, defineds.endOfQ2); }},
  { label: `Q3 ${year}`, range: () => ({ startDate: defineds.startOfQ3, endDate: defineds.endOfQ3 }), isSelected(range) { return isSameDay(range.startDate, defineds.startOfQ3) && isSameDay(range.endDate, defineds.endOfQ3); }},
  { label: `Q4 ${year}`, range: () => ({ startDate: defineds.startOfQ4, endDate: defineds.endOfQ4 }), isSelected(range) { return isSameDay(range.startDate, defineds.startOfQ4) && isSameDay(range.endDate, defineds.endOfQ4); }},
];


// --- Nuestro nuevo componente con el panel manual ---
function CustomDateRange({ range, handleDateChange, setIsDatePickerOpen }) {
  
  // Esta nueva función se encarga de manejar el clic en nuestros botones Q1, Q2...
  const handleStaticRangeClick = (staticRange) => {
    const newRange = staticRange.range(); // Llama a la función que devuelve { startDate, endDate }
    
    // El `handleDateChange` espera un formato específico, así que lo adaptamos
    handleDateChange({
      selection: {
        ...range[0], // Mantenemos la 'key' y otras props
        ...newRange, // Sobreescribimos con las nuevas startDate y endDate
      },
    });

    // Opcional pero recomendado: cierra el pop-up después de seleccionar un rango predefinido
    setIsDatePickerOpen(false);
  };

  return (
    // 1. Contenedor principal que creamos con Flexbox
    <div style={{ display: 'flex' }}>
      
      {/* 2. Nuestro panel izquierdo MANUAL */}
      <div
        className="d-flex flex-column p-2 bg-light border-end"
        style={{ width: '200px' }}
      >
        <h6 className="text-muted ms-2 mt-1 mb-2">Rangos Rápidos</h6>
        {/* Mapeamos nuestros rangos para crear los botones */}
        {customStaticRanges.map((staticRange, index) => (
          <Button
            key={index}
            variant={staticRange.isSelected(range[0]) ? 'primary' : 'light'}
            className="text-start mb-1"
            onClick={() => handleStaticRangeClick(staticRange)}
          >
            {staticRange.label}
          </Button>
        ))}
      </div>

      {/* 3. A la derecha, el componente de calendario que SÍ funciona */}
      <div>
         <rdr.DateRange
        locale={es}
        months={1} // Puedes volver a poner 2 meses si quieres
        direction="horizontal"
        showSelectionPreview={true}
        moveRangeOnFirstSelection={false}
        ranges={range}
        onChange={handleDateChange}

        // --- LA SOLUCIÓN ESTÁ AQUÍ ---
        // Para ocultar el panel por defecto, simplemente pasa un array vacío.
        staticRanges={[]}
        
        // Mantenemos este también vacío para una interfaz limpia.
        inputRanges={[]}
    />
      </div>
    </div>
  );
}

export default CustomDateRange;